<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i class="calibre8">Dedicated to those without memorial or monument</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?4fdfcfaa